import { Close } from '@mui/icons-material'
import { AppBar, Button, CircularProgress, Dialog, DialogContent, Grid, IconButton, Toolbar, Typography } from '@mui/material'
import { Suspense, lazy } from 'react'
import { useDispatch } from 'react-redux'

import { useHideModal, useModal } from '../../hooks/ModalWrapperHooks'

function ModalWrapper() {
  const dispatch = useDispatch()
  const { modal } = useModal()
  const { handleOnClose } = useHideModal()
  const CustomComponent = lazy(() => import(`${modal.modal.componentPath}`))

  return (
    <Dialog
      open={modal.showModal}
      fullScreen
      onClose={handleOnClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <AppBar position="static">
        <Toolbar>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h6" color="primary">
                {modal.modal.title && modal.modal.title}
              </Typography>
            </Grid>

            <Grid item>
              <Button
                autoFocus
                id="btn-handlelogin"
                variant="contained"
                color="primary"
                style={{ marginRight: '15px' }}
                onClick={() => {
                  dispatch(modal.actionButton)
                }}
              >
                {modal.modal.textPrimaryButton && modal.modal.textPrimaryButton}
              </Button>
              <IconButton edge="start" color="inherit" onClick={handleOnClose} aria-label="close">
                <Close color="primary" />
              </IconButton>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <DialogContent>
        <Suspense fallback={<CircularProgress disableShrink />}>
          {modal.modal.componentPath ? <CustomComponent {...modal.modal.componentProps} /> : modal.modal.body}
        </Suspense>
      </DialogContent>
    </Dialog>
  )
}

export default ModalWrapper
